import { apiFetch } from './client';
import type { ProjectStat, RevealResponse } from './types';

export const getProjects = () => apiFetch<ProjectStat[]>('/projects');

// Owner/admin only; access-audited decrypt of a request's vaulted originals.
export const revealRequest = (id: string) =>
  apiFetch<RevealResponse>(`/audit/requests/${id}/reveal`, { method: 'POST' });
